import FavoritesListProvider from './FavoritesListProvider';

export default FavoritesListProvider;
